import { ZMANIM_METADATA } from '../constants/metadata';
import { resolveDateTimeStatus } from './date';
import { hourFromCompactTime, isIsraelDst, minuteFromCompactTime } from './time';

export function calculateTfilaOffset(tfila, zmanim, date, applyDstOffset = true) {
  const offsetDirection = tfila.crfd1_offset === 648970000 ? -1 : 1;
  const relativeZman = ZMANIM_METADATA.find((item) => item.key === tfila.crfd1_relativeto)?.index;
  const zmanValue = relativeZman ? zmanim[relativeZman] : null;

  let hours =
    (zmanValue
      ? hourFromCompactTime(zmanValue) + (applyDstOffset && isIsraelDst(date) ? 1 : 0)
      : 0) +
    offsetDirection * tfila.crfd1_hours;
  let minutes = (zmanValue ? minuteFromCompactTime(zmanValue) : 0) + offsetDirection * tfila.crfd1_minutes;

  switch (tfila.crfd1_rounddirection) {
    case 648970000:
      minutes = Math.floor(minutes / tfila.crfd1_roundminutes) * tfila.crfd1_roundminutes;
      break;
    case 648970001:
      minutes = Math.ceil(minutes / tfila.crfd1_roundminutes) * tfila.crfd1_roundminutes;
      break;
    case 648970002:
      minutes = Math.round(minutes / tfila.crfd1_roundminutes) * tfila.crfd1_roundminutes;
      break;
    default:
      break;
  }

  const minMinutes = tfila.crfd1_hoursmin * 60 + tfila.crfd1_minutesmin;
  const maxMinutes = tfila.crfd1_hoursmax * 60 + tfila.crfd1_minutesmax;
  const totalMinutes = hours * 60 + minutes;

  if (tfila.crfd1_hoursmin !== null && tfila.crfd1_minutesmin !== null && totalMinutes < minMinutes) {
    hours = tfila.crfd1_hoursmin;
    minutes = tfila.crfd1_minutesmin;
  }

  if (tfila.crfd1_hoursmax !== null && tfila.crfd1_minutesmax !== null && totalMinutes > maxMinutes) {
    hours = tfila.crfd1_hoursmax;
    minutes = tfila.crfd1_minutesmax;
  }

  if (minutes >= 60) {
    hours += 1;
    minutes -= 60;
  }

  if (minutes < 0) {
    hours -= 1;
    minutes += 60;
  }

  if (hours < 0) {
    hours += 24;
  }

  return {
    hours: hours % 24,
    minutes
  };
}

export function resolveStatus(start, end, startThresholdMinutes, now) {
  return resolveDateTimeStatus(start, end, startThresholdMinutes, now);
}

export function sortScheduleByTime(items = []) {
  return [...items].sort((a, b) => a.hours * 60 + a.minutes - (b.hours * 60 + b.minutes));
}
